import menu from 'data/menu.json';

// constants
const DEFAULT_USER_TYPES = [ 'HQ', 'INST', 'BC' ];

/**
 * menuReducer
 * 
 * Reducer for items in menu to limit by type (code) provided
 * 
 * @param {string} user_type The type of user (e.g. HQ, INSTITUTION, BC, PARENT) that we are filtering the menu for
 * @param {Array} defaults Array of defaults in the event that the item does not have a user_types array
 * 
 * @returns {function} Returns a valid reducer to be passed to .reduce with an array as the initilaizer
 */
export const menuReducer = ( login, current_user, defaults = DEFAULT_USER_TYPES ) => ( filtered = [], item ) => {
  const { code, legacy, modules } = login;
  // reduce the items down a bit
  if ( item.items ) {
    item = Object.assign( {}, item, 
      { items: item.items.reduce(
        menuReducer(login, current_user, item.user_types || defaults ), 
        []
      )}
    );
    // if there are no valid items, hide the dropdown
    if ( item.items.length === 0 ) {
      return filtered;
    }
  }
  // do not show this dropdown if we are hiding it
  if (
    ( !legacy && item.legacy ) // hide legacy links from new institutions
    // OR hide menu if login does not have access to this module
    || ( item.module && modules && !modules[ item.module ] )
  ) return filtered;

  // If we are controlling for beta
  if ( item.beta !== undefined ) {
    if ( // the user is in beta and the link is not
      ( current_user.beta && !item.beta ) ||
      // OR the user is not in beta and the link is
      ( !current_user.beta && item.beta )
    ) {
      return filtered;
    }
  }
  
  // if the item is enabled for that code, add it to the sidebar
  if ( item.user_types && item.user_types.indexOf( code ) > -1 ) {
    filtered.push( item );
  // if the default for this section contains this code, add it
  } else if ( !item.user_types && defaults.indexOf( code ) > -1 ) {
    filtered.push( item );
  }
  
  return filtered;
}

/**
 * getMenu
 * 
 * returns an array for the user_type provided to get their sidebar menu
 * 
 * @param {string} user_type The type of user to get the menu for 
 */
const getMenu = ( login, current_user ) => {

  if ( Object.keys( login ).length === 0 )
    return [];

  // Define the shape of the menu

  // filter the menu and return it
  return menu.reduce( menuReducer( login, current_user ), [] );
} // end getMenu function

// export getMenu by default
export default getMenu;


// WEBPACK FOOTER //
// ./src/components/navigation/Sidebar/menu.js